<template>
    <div class="row-container" :class="{clickable, selected}">
        <div class="row">
            <slot></slot>
            <div class="overflow-menu" v-show="overflowing === true">
                <sc-table-button :icon="(viewingOverflowMenu)?'times':'ellipsis-h'"
                                 @click.native="viewingOverflowMenu = true"></sc-table-button>
            </div>
        </div>

        <div class="overflow-options" v-if="viewingOverflowMenu">
            <div class="backdrop" @click.self="viewingOverflowMenu = false">
            </div>
            <div class="options">
                <slot name="overflowy">

                </slot>
            </div>
        </div>

    </div>
</template>

<script>
export default {
  name: "sc-table-row",
  props: ['clickable', 'selected', 'overflowing'],

  data() {
    return {
      viewingOverflowMenu: false,
    }
  }
}
</script>

<style scoped lang="scss">
.row-container {
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    /*box-shadow: 5px 5px 10px 3px rgba(100, 100, 100, 0.10);*/
    margin-right: 0px;
    transition-property: top, background;
    transition-duration: .2s, .15s;
    transition-timing-function: ease-in-out;
    padding: 0 16px;
}

.row-container.clickable {
    cursor: pointer;
}

.row-container.clickable:hover {

}

.row {
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
}


.overflow-menu {
    position: absolute;
    right: 8px;
    top: 0px;
}

.overflow-options {
    position: absolute;
    right: 0;
    top: 0;
    max-width: 80%;

    padding: 1.6em 1.5em 1em 1.5em;
    margin-bottom: 1em;

    .backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 10;
    }

    .options {
        position: relative;
        z-index: 11;
        display: flex;
        flex-wrap: wrap;
        background: #fff;
        padding: 0.6em 0.5em 0.2em;
        //box-shadow: 2px 1px 10px 1px rgba(0, 0, 0, 0.15);
        border: 1px solid #ddd;
        border-radius: 0.3em 0 0.3em 0.3em;
    }
}

</style>